import { render, staticRenderFns } from "./BoxedContent.vue?vue&type=template&id=65f1d3b2&"
import script from "./BoxedContent.vue?vue&type=script&lang=js&"
export * from "./BoxedContent.vue?vue&type=script&lang=js&"
import style0 from "./BoxedContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports